import React from 'react'
import { Dialog, DialogContent, IconButton, Box } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

interface HelpVideoModalProps {
  open: boolean
  onClose: () => void
  url: string
}

/**
 * Convert various YouTube URL formats to embeddable URL
 * Handles: youtu.be/ID, youtube.com/watch?v=ID, youtube.com/embed/ID
 */
function toEmbedUrl(url: string): string {
  // Already an embed URL
  if (url.includes('/embed/')) return url

  // youtu.be/ID format
  const shortMatch = url.match(/youtu\.be\/([a-zA-Z0-9_-]+)/)
  if (shortMatch) return `https://www.youtube.com/embed/${shortMatch[1]}`

  // youtube.com/watch?v=ID format
  const longMatch = url.match(/[?&]v=([a-zA-Z0-9_-]+)/)
  if (longMatch) return `https://www.youtube.com/embed/${longMatch[1]}`

  return url
}

const HelpVideoModal: React.FC<HelpVideoModalProps> = ({ open, onClose, url }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    fullWidth
    PaperProps={{ sx: { borderRadius: 0 } }}
  >
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
      <IconButton size="small" onClick={onClose} sx={{ color: 'text.secondary' }}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
    <DialogContent sx={{ p: 0, pb: 0 }}>
      <Box sx={{ position: 'relative', width: '100%', paddingTop: '56.25%' }}>
        <iframe
          src={toEmbedUrl(url)}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 'none',
          }}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </Box>
    </DialogContent>
  </Dialog>
)

export default HelpVideoModal
